// extracted by mini-css-extract-plugin
export default {"body":"exit-interview-modal_body__x8ntu","description":"exit-interview-modal_description__O4lEO","footer":"exit-interview-modal_footer__YQ5TJ"};